export default "__VITE_ASSET__DV45eKxB__"